import { NotificationManager } from 'react-notifications';
import axios from 'axios';

import { ISite } from './types';

export const fetchSiteByIdRequest = async (id: string): Promise<ISite | null> => {
  try {
    const res = await axios.get(`api/v1/sites/${id}`);
    return res.data;
  } catch (error) {
    NotificationManager.error(`Can't fetch site ${id}`);
    return null;
  }
};

export const createSiteRequest = async (data: Partial<ISite>): Promise<ISite | null> => {
  try {
    const res = await axios.put('api/v1/sites', data);
    return res.data;
  } catch (error) {
    NotificationManager.error(`Can't create site`);
    return null;
  }
};

export const updateSiteRequest = async ({ id, createdAt, updatedAt, identity, ...data }: Partial<ISite>): Promise<ISite | null> => {
  try {
    const res = await axios.post(`api/v1/sites/${id}`, data);
    return res.data;
  } catch (error) {
    NotificationManager.error(`Can't update site`);
    return null;
  }
};
